export const tMap = new Map<symbol, () => void>();
